import { Box3, Vector3, Mesh } from 'three'

export function calculateCameraPositionAgainstModel({ model, rotationAngle, scaleFactor, fov, aspectRatio, padding = 10 }) {
  const originalRotation = model.rotation.y;
  model.rotation.y = 0;
  // Calculate the model's bounding box
  let modelBox = new Box3().setFromObject(model)
  // NOTE: it's not the best approach but since we had incosistency in models bounding box it's more corect to build bounding box around floor plan
  model.traverse((mesh) => {
    if (mesh instanceof Mesh && mesh.name.toLowerCase() === 'fp') {
      modelBox = new Box3().setFromObject(mesh)
    }
  })
  const { x: modelWidth, z: modelDepth } = modelBox.getSize(new Vector3())
  model.rotation.y = originalRotation;
  const fovInRad = (fov * Math.PI) / 180

  // Use the larger of width or depth
  const maxModelSide = Math.max(modelWidth, modelDepth)
  const distanceFromCenter = (maxModelSide + (maxModelSide * padding / 100)) / (2 * Math.tan(fovInRad / 2))
  const radius = (distanceFromCenter * (1 + aspectRatio * (padding * 2 / 100))) / aspectRatio / scaleFactor
  const radians = -rotationAngle * Math.PI / 180 // Convert angle to radians

  // Calculate the new camera position
  const x = +(radius * Math.sin(radians)).toFixed(3)
  const z = +(radius * Math.cos(radians)).toFixed(3)
  const y = +(radius/2.5).toFixed(3)

  return [x, y, z]
}

export function calculateCameraPositionTopViewAgainstModel({
  model,
  scaleFactor,
  fov,
  aspectRatio,
}) {
  const originalRotationY = model.rotation.y;
  const originalRotationX = model.rotation.x;
  model.rotation.y = 0;
  model.rotation.x = 0;

  let modelBox = new Box3().setFromObject(model);
  model.traverse((mesh) => {
    if (mesh instanceof Mesh && mesh.name.toLowerCase() === 'fp') {
      modelBox = new Box3().setFromObject(mesh);
    }
  });

  const { x: modelWidth, z: modelDepth } = modelBox.getSize(new Vector3());
  model.rotation.y = originalRotationY;
  model.rotation.x = originalRotationX;

  const isHorizontalScreen = aspectRatio > 1 
  // const padding = isHorizontalScreen ? 0 : 1
  const padding = 1


  const fovInRad = (fov * Math.PI) / 180;
  const horizontalFovInRad = 2 * Math.atan(Math.tan(fovInRad / 2) * aspectRatio);
  const finalFovInRad = isHorizontalScreen ? fovInRad : horizontalFovInRad

  const widthWithPadding = modelWidth + padding;
  const depthWithPadding = modelDepth + padding;

  const diagonal = Math.sqrt(widthWithPadding ** 2 + depthWithPadding ** 2)

  const distance = (diagonal / 2) / Math.tan(finalFovInRad / 2);
  const finalDistance = distance / scaleFactor;

  return [finalDistance, 0, 0];
}

export function calculateCameraDistance({ cameraPosition, scaleFactor }) {
  // TODO: has to be enabled back since it's more correct way of calculatin distance to model
  // but 3d artists tend to make mistakes centering position of the model and then everyone points to devs saying that it's regression on our side and we are source of all problems
  // const modelBox = new Box3().setFromObject(model)
  // modelBox.getCenter(center)
  const maxDistance = cameraPosition.distanceTo(new Vector3())

  return {
    near: maxDistance / 100,
    far: maxDistance * 10,
    maxDistance: maxDistance,
    minDistance: maxDistance * scaleFactor / 2.5,
  }
}